module.exports = __webpack_public_path__ + "static/media/steampodResale.820017a3.png";